
export const getFooterLinks = (baseUrl) => [
  {
    title: 'Manage logins',
    link: `${baseUrl}/v2/accountsettings/manage_login_access.html`
  },
  {
    title: 'Security center',
    link: 'https://www.foundit.in/info/security-center'
  },
  {
    title: 'Help center',
    link: `${baseUrl}/SelfHelp/`
  },
  {
    title: 'Buy Job Postings',
    link: `${baseUrl}/v2/ecom/`
  },
  {
    title: 'Buy Resume Database Access',
    link: `${baseUrl}/v2/ecom/`
  },
  {
    title: 'Advertise with Us',
    link: `${baseUrl}/branding-solutions.html`
  },
];


